export default "__VITE_ASSET__DwsxjAWn__"